<template>
  <SubTitle :TitleName="'店舗特典'" />
  <p class="text-Body1 text-center ma-auto pa-3">
          店舗特典はShuzilow.HA先生によるフェイスロード画像になります。
        </p>
  <v-row class="pa-5 mx-auto" justify="start" align="stretch" style="max-width: 1200px;">
    <v-col
      v-for="(card, index) in items"
      :key="card"
      cols="12"
      sm="6"
      :md="index < 2 ? 6 : 4"
      align-self="stretch"
    >
      <v-card class="mx-auto pa-6 card-grid" max-width="350"  width="100%" variant="tonal">
        <template v-slot:title>
          <span class="font-weight-black">{{ card.shop }}</span>
        </template>
        <v-img :src="getImageHero(card.imageUrl)"
          ><template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular
                color="grey-lighten-4"
                indeterminate
              ></v-progress-circular>
            </div> </template
        ></v-img>
        <v-card-text class="bg-surface-light pt-4">
          {{ card.content }}
        </v-card-text>
        <!-- <v-card-actions class="flex-column justify-center">
          <v-btn
            variant="outlined"
            class="mx-auto text-capitalize my-2"
            align="center"
            color="primary"
            :href="card.linkURL1"
            target="_blank"
            rel="noopener noreferrer"
            block
            height="72"
          >
            <div class="card-text">ご予約はこちら</div>
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  import SubTitle from "./SubTitle.vue";
  export default {
    components: {
      SubTitle,
    },
    methods: {
      getImageHero(imagePath) {
        if (!imagePath) {
          return require("@/assets/store_nowprinting.png"); // デフォルト画像を src/assets に配置
        }

        try {
          return require(`@/assets/${imagePath}`); // src/assets 配下の画像を取得
        } catch (e) {
          console.error("画像の取得に失敗しました:", e);
          return require("@/assets/store_nowprinting.png");
        }
      },
    },

    data: () => ({
      items: [
        {
          shop: "Amazon様",
          imageUrl: "Human.png",
          linkURL1: "https://amzn.asia/d/axBt1xH", //限定
          content: "フェイスロード用データ「人間　男」",
        },
        {
          shop: "GEO様",
          imageUrl: "Elf.png",
          linkURL1:
            "https://shop.1983.jp/shop/shop.cgi?order=&class=all&keyword=%92j%8Eq%8DZ%82%C5%82%A0%82%C1%82%BD%95%7C%82%A2%98b&FF=0&price_sort=&pic_only=&mode=p_wide&id=40786&superkey=1", //限定
          content:
            "フェイスロード用データ「エルフ　女」",
        },
        {
          shop: "店舗様特典A",
          imageUrl: "Dwarf.png",
          content: "フェイスロード用データ「ドワーフ　男」",
        },
        {
          shop: "店舗様特典B",
          imageUrl: "Fairy.png",
          linkURL1:
            "https://www.stellaworth.co.jp/shop/item.php?item_id=BLADoxerAKe",
          content:
            "フェイスロード用データ「フェアリー　女」",
        },
        {
          shop: "店舗様特典C",
          imageUrl: "Dragonewt.png",
          content:
            "フェイスロード用データ「ドラゴニュート　男」",
        },
      ],
    }),
  };
</script>
<style scoped>
.card-grid {
  display: grid;
  grid-template-rows:
    auto   /* title */
    auto   /* image */
    1fr    /* content（ここだけ伸びる） */
    auto;  /* buttons */
}
</style>